var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158,452c0,33.1,26.9,60,60,60h234c33.1,0,60-26.9,60-60V218c0-33.1-26.9-60-60-60h-96v-40h-40v40h-98 c-33.1,0-60,26.9-60,60v96h-39v40h39V452z M198,218c0-11,9-20,20-20h234c11,0,20,9,20,20v234c0,11-9,20-20,20H218c-11,0-20-9-20-20 V218z M40,80H0V40C0,17.9,17.9,0,40,0h39v40H40V80z M239,40h-40V0h40V40z M159,40h-40V0h40V40z M0,314v-40h40v40h39v40H40 C17.9,354,0,336.1,0,314z M40,236H0v-40h40V236z M40,158H0v-40h40V158z M316,40h-39V0h39c22.1,0,40,17.9,40,40v40h-40V40z M279,358 h-40V238h120v40h-51.7l71.4,71.4l-28.3,28.3L279,306.3V358z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.ee4c8ef9ed5994ac277ee056a2bf6068.svg";
export { ForwardRef as ReactComponent };